import { isNumber, zaokr, objIsNotEmpty, isObject } from "./utilities";
import { findMieszkanieId } from "./ulice";
import { dataFormatMsc, mm_rrrr_to_date, dataFormat3, dataFormat4, dzien } from "./dataFormat";
import { hasKey } from "./tablice";

export const odczytOpis = odczytWm => `Rozliczenie wody za okres ${odczytWm?.okres_poczatek} - ${odczytWm?.okres_koniec}`;

export const obliczRozliczenieWody = ( 
    odczyty, odczytyWm, lokale, udzialyKontaAkt, grupy, tablicaCzynsze 
) => {
    return odczytyWm?.map( wybranyZakres => 
    obliczStrate(odczyty, wybranyZakres, lokale, udzialyKontaAkt, grupy, tablicaCzynsze)
    )
};

export const rozliczenieWodyMAkt = rozliczeniaM => {
    const rozliczeniaPoKluczach = {};
    rozliczeniaM?.forEach( rozliczenie => {
        const klucz = `${rozliczenie.id_wspolnoty}-${rozliczenie.id_user}-${rozliczenie.grupa_numer}-${rozliczenie.id_odczytu_wm}`;
        if (!rozliczeniaPoKluczach[klucz] || new Date(rozliczeniaPoKluczach[klucz].data_utworzenia) < new Date(rozliczenie.data_utworzenia) && rozliczenie.czyRozliczac == 1) {
            rozliczeniaPoKluczach[klucz] = rozliczenie;
        }
    });
    return objIsNotEmpty(rozliczeniaPoKluczach) ? Object.values(rozliczeniaPoKluczach) : undefined;
}

export const rozliczenieWodyWmAkt = rozliczeniaWody => {
    const rozliczeniaPoKluczach = {};
    rozliczeniaWody?.forEach( rozliczenie => {
        const klucz = `${rozliczenie.id_wspolnoty}-${rozliczenie.id_odczytu_wm}`;
        if (!rozliczeniaPoKluczach[klucz] || new Date(rozliczeniaPoKluczach[klucz].data_utworzenia) < new Date(rozliczenie.data_utworzenia) && rozliczenie.opublikowany == 1) {
            rozliczeniaPoKluczach[klucz] = rozliczenie;
        }
    });
  return objIsNotEmpty(rozliczeniaPoKluczach) ? Object.values(rozliczeniaPoKluczach): undefined;
}

const obliczLiczbaMsc = (d1, d2) => {
    if (!d1 || !d2) return;

    const start = new Date(d1);
    const end = new Date(d2);

    const yearDiff = end.getFullYear() - start.getFullYear();
    const monthDiff = end.getMonth() - start.getMonth();

    return yearDiff * 12 + monthDiff + 1;
}

const znajdzNajblizszyOd = (tablica, data_od) => {
  return tablica?.reduce((najblizszy, obiekt) => {
    const dataObiektu = new Date(obiekt.dzien);
    const roznicaAktualna = Math.abs(dataObiektu - new Date(data_od));
    const roznicaNajblizsza = Math.abs(new Date(najblizszy.dzien) - new Date(data_od));

    return roznicaAktualna < roznicaNajblizsza ? obiekt : najblizszy;
  });
}

function resetTime(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

const znajdzNajstarszaDo = (tablica, data_do) => {
  const dataDoReset = resetTime(data_do);

  const kandydaci = tablica?.filter(obj => resetTime(obj.dzien) <= dataDoReset);
  if (!kandydaci?.length) return null;

  return kandydaci?.reduce((najstarsza, obj) =>
    resetTime(obj.dzien) > resetTime(najstarsza.dzien) ? obj : najstarsza
  );
}

export const obliczStrate = ( odczyty, wybranyZakres, lokale, udzialyKontaAkt, grupy, tablicaCzynsze ) => {

    const odczytyZamkniete = odczyty ? odczyty?.filter( o => o.okres_poczatek !== null && o.okres_koniec !== null) : [];
    const odczytyWZakresie = odczytyZamkniete?.filter( o => new Date(o?.okres_poczatek) >= new Date(wybranyZakres?.okres_poczatek) && new Date(o?.okres_koniec) <= new Date(wybranyZakres?.okres_koniec) );

    let cieplaM = 0, zimnaM = 0, metrazRazem = 0, abonamentRazem = 0, kosztZimnejRazem = 0, kosztPodgrzaniaRazem = 0, razemZwCwAboTotal = 0;
    let zaliczka_zimna_total = 0, zaliczka_ciepla_total = 0, zaliczka_abonament_total = 0, zaliczka_total = 0;
    let strataTotal = 0;

    const policzZaliczke = (udzial, tablicaCzynsze, wybranyZakres, ile_dni_total) => {
        
        const czynsze1 = tablicaCzynsze?.find( t => t?.id_user == udzial?.id_user);
        const czynsze2 = czynsze1?.grupy_udzial_msc?.find( c => c?.grupa_numer == udzial?.grupa_numer)?.temp_msc;        
        const czynsze3 = czynsze2?.filter( c => new Date(mm_rrrr_to_date(c?.msc)) >= new Date(wybranyZakres?.okres_poczatek) && new Date(mm_rrrr_to_date(c?.msc)) <= new Date(wybranyZakres?.okres_koniec));

        const zaliczka_cw = czynsze3?.reduce((acc, obj) => acc + obj.ciepla_woda, 0) || 0;
        const zaliczka_zw = czynsze3?.reduce((acc, obj) => acc + obj.zimna_woda, 0) || 0;
        const zaliczka_abo_cw = czynsze3?.reduce((acc, obj) => acc + obj.abonament_cw, 0) || 0;
        const zaliczka_razem = parseFloat(zaliczka_cw) + parseFloat(zaliczka_zw) + parseFloat(zaliczka_abo_cw) || 0;
        
        const czynsze_dni = czynsze1?.grupy_dni?.find( g => g?.grupa_numer == udzial?.grupa_numer)?.temp_dni;

        const zaliczki_data_poczatek = znajdzNajblizszyOd(czynsze_dni, wybranyZakres?.okres_poczatek);
        const zaliczki_data_koniec = znajdzNajstarszaDo(czynsze_dni, wybranyZakres?.okres_koniec);

        // if (udzial?.id_user ==  953 || udzial?.id_user == 115) {
        // console.log('****')
        // console.log(wybranyZakres?.okres_koniec);
        // console.log(new Date(zaliczki_data_poczatek?.dzien))
        // console.log(new Date(zaliczki_data_koniec?.dzien))
        // }

        // console.log(czynsze_dni)


        const tablica_dni = czynsze1?.grupy_dni?.find( g => g?.grupa_numer == udzial?.grupa_numer)?.temp_dni;
        const dni_w_zakresie = tablica_dni?.filter( t => new Date(t?.dzien) >= new Date(wybranyZakres?.okres_poczatek) && new Date(t?.dzien) <= new Date(wybranyZakres?.okres_koniec));

        const ile_dni_mieszkaniec = dni_w_zakresie?.length;
        
        const dni_proc = ile_dni_mieszkaniec / ile_dni_total;

        const id_lokal = findMieszkanieId(udzial, grupy, lokale);
        const metraz = lokale?.find( l => l?.id == id_lokal)?.metraz;
        const metrazProc = metraz * dni_proc;

        const temp = dni_w_zakresie?.map( dzien => {
            
            return ({
                dzien: dzien.dzien,
                id_user: udzial?.id_user,
                grupa_numer: udzial?.grupa_numer,
                id_lokal
            })
        });

        return ({
            zaliczka_cw, 
            zaliczka_zw, 
            zaliczka_abo_cw, 
            zaliczka_razem, 
            temp, 
            ile_dni: ile_dni_mieszkaniec,
            metrazProc,
            dni_proc,
            zaliczki_data_poczatek,
            zaliczki_data_koniec
        })
    }
    
    const ile_dni_total = zaokr((new Date(wybranyZakres?.okres_koniec) - new Date(wybranyZakres?.okres_poczatek)) / (1000 * 60 * 60 * 24),0);

    const tabMieszkania = [];
    
    udzialyKontaAkt?.forEach( (udzialKonto, i) => {
        
        const o = odczytyWZakresie?.find( o => o?.id_user == udzialKonto?.id_user && o?.grupa_numer == udzialKonto?.grupa_numer);
    
        const c = o?.ciepla_stan_koniec - o?.ciepla_stan_poczatek;
        cieplaM += (c || 0);
        const z = o?.zimna_stan_koniec - o?.zimna_stan_poczatek;
        zimnaM += (z || 0);

        const id_lokal = findMieszkanieId(udzialKonto, grupy, lokale);
        
        const zaliczka = policzZaliczke(udzialKonto, tablicaCzynsze, wybranyZakres, ile_dni_total);
        
        if (!tabMieszkania?.find( t => t?.id_lokal == id_lokal && t?.id_user == udzialKonto.id_user && t.grupa_numer == udzialKonto.grupa_numer) && zaliczka.zaliczka_razem > 0)
            tabMieszkania.push({id_lokal, metrazProc: zaliczka?.metrazProc, ile_dni: zaliczka?.ile_dni, id_user: udzialKonto.id_user, grupa_numer: udzialKonto.grupa_numer});

        metrazRazem += c + z <= 0 && zaliczka.zaliczka_razem == 0 ? 0 : zaliczka?.metrazProc; 
    }); 

    const zuzycieM = cieplaM + zimnaM;

    const cieplaWm = isNumber(wybranyZakres?.ciepla_stan_poczatek) && isNumber(wybranyZakres?.ciepla_stan_koniec) ? wybranyZakres?.ciepla_stan_koniec - wybranyZakres?.ciepla_stan_poczatek : 0;
    const zimnaWm = isNumber(wybranyZakres?.zimna_stan_poczatek) && isNumber(wybranyZakres?.zimna_stan_koniec) ? wybranyZakres?.zimna_stan_koniec - wybranyZakres?.zimna_stan_poczatek : 0;
    
    const liczbaMsc = obliczLiczbaMsc(wybranyZakres?.okres_poczatek, wybranyZakres?.okres_koniec);

    const strata = (zimnaWm - zimnaM) + (cieplaWm - cieplaM);
    const podgrzanieWody = wybranyZakres?.moc_zamowiona + wybranyZakres?.energia_pobrana;
    
    const abonament_dzien = wybranyZakres?.moc_zamowiona > 0 && ile_dni_total > 0 && metrazRazem > 0 ? wybranyZakres?.moc_zamowiona / ile_dni_total / metrazRazem : 0;

    const kosztPodgrzaniaCieplej = cieplaM > 0 ? (wybranyZakres?.energia_pobrana / cieplaM) : 0;
    
    const procenty = udzialyKontaAkt?.map( (udzialKonto, i) => {

        const odczyt = odczytyWZakresie?.find( o => o?.id_user == udzialKonto?.id_user && o?.grupa_numer == udzialKonto?.grupa_numer);

        const zuzycieMieszkancaZimna = odczyt ? odczyt.zimna_stan_koniec - odczyt.zimna_stan_poczatek : 0;
        const zuzycieMieszkancaCiepla = odczyt ? odczyt.ciepla_stan_koniec - odczyt.ciepla_stan_poczatek : 0;
        const zuzycieMieszkanca = zuzycieMieszkancaCiepla + zuzycieMieszkancaZimna;

        const zaliczka = policzZaliczke(udzialKonto, tablicaCzynsze, wybranyZakres, ile_dni_total);

        const {zaliczka_zw, zaliczka_cw, zaliczka_abo_cw, zaliczka_razem, ile_dni, dni_proc, metrazProc, zaliczki_data_poczatek, zaliczki_data_koniec} = zaliczka;

        zaliczka_zimna_total += zaliczka_zw;
        zaliczka_ciepla_total += zaliczka_cw;
        zaliczka_abonament_total += zaliczka_abo_cw;
        zaliczka_total += zaliczka_razem;

        const czyRozliczac = zuzycieMieszkanca == 0 && zaliczka_razem == 0 ? false : true;
        
        const kosztZimnej = (zuzycieMieszkancaZimna + zuzycieMieszkancaCiepla) * wybranyZakres?.metr_3_zimnej;
        kosztZimnejRazem += kosztZimnej;
        const procMieszkanca = czyRozliczac && zuzycieMieszkanca > 0 && zuzycieM > 0 ? zaokr((zuzycieMieszkanca / zuzycieM) * 100, 2) : 0;
        const strataMieszkancaMetry = czyRozliczac ? zaokr(procMieszkanca * strata / 100, 2) : 0;
            
        const strataMieszkancaKwota = czyRozliczac ? strataMieszkancaMetry * wybranyZakres?.metr_3_zimnej : 0;
        strataTotal += strataMieszkancaKwota;
        const id_lokal = findMieszkanieId(udzialKonto, grupy, lokale);

        const metraz = lokale?.find( l => l?.id == id_lokal)?.metraz;
        const abonament = czyRozliczac ? metraz * abonament_dzien * ile_dni: 0;
        const abonament_pozorny = czyRozliczac ? metraz * abonament_dzien * ile_dni_total : 0;
        const abonament_pozorny_msc = czyRozliczac ? abonament_pozorny / liczbaMsc / metraz : 0;
        const abonament_pozorny_mnoznik = abonament / (abonament_pozorny / liczbaMsc);
        const abonament_pozorny_1msc = abonament / abonament_pozorny_mnoznik;

        abonamentRazem += abonament;
        
        const podgrzanieWody = zuzycieMieszkancaCiepla * kosztPodgrzaniaCieplej;
        kosztPodgrzaniaRazem += podgrzanieWody || 0;

        razemZwCwAboTotal += kosztZimnej + abonament + podgrzanieWody;

        const razemZwCwAbo = kosztZimnej + abonament + podgrzanieWody;
        const saldo = zaliczka_razem - (razemZwCwAbo + strataMieszkancaKwota);

        let opis = "Razem";

        if (saldo > 0) {
            opis = "Nadpłata"
        } else if (saldo < 0) {
            opis = "Niedopłata"
        }

        return {
            id: i,
            id_user: udzialKonto.id_user,
            id_wspolnoty: udzialKonto.id_wspolnoty,
            id_odczytu_wm: wybranyZakres?.id,
            grupa_numer: udzialKonto.grupa_numer,
            zuzycieMieszkanca,
            procMieszkanca: zaokr(procMieszkanca),
            strataMieszkancaMetry: zaokr(strataMieszkancaMetry),
            strataMieszkancaKwota: zaokr(strataMieszkancaKwota),
            metraz,
            metrazProc: zaokr(metrazProc, 2),
            zuzycieMieszkancaZimna,
            zuzycieMieszkancaCiepla,
            kosztZimnej,
            abonament: zaokr(abonament),
            abonament_pozorny: zaokr(abonament_pozorny),
            abonament_pozorny_msc: zaokr(abonament_pozorny_msc),
            abonament_pozorny_mnoznik: zaokr(abonament_pozorny_mnoznik, 1),
            abonament_pozorny_1msc: zaokr(abonament_pozorny_1msc),
            ile_dni,
            dni_proc,
            podgrzanieWody: zaokr(podgrzanieWody),
            razemZwCwAbo: zaokr(razemZwCwAbo),
            zaliczka_cw: zaokr(zaliczka_cw),
            zaliczka_zw: zaokr(zaliczka_zw),
            zaliczka_abo_cw: zaokr(zaliczka_abo_cw),
            zaliczka_razem: zaokr(zaliczka_razem),
            saldo: zaokr(saldo),
            czyRozliczac,
            opis,
            zaliczki_data_poczatek: zaliczki_data_poczatek?.dzien,
            zaliczki_data_koniec: zaliczki_data_koniec?.dzien
        }
    });

    const opis = wybranyZakres?.okres_koniec 
        ? `Rozliczenie wody za okres ${dataFormat4(wybranyZakres?.okres_poczatek)} - ${dataFormat4(wybranyZakres?.okres_koniec)}` 
        : `Rozliczenie wody za okres ${dataFormat4(wybranyZakres?.okres_poczatek)} - brak`;
    
    const miesiac = wybranyZakres?.miesiac ? dataFormatMsc(wybranyZakres?.miesiac) : null;

    return {
        id: wybranyZakres?.id,
        id_wspolnoty: wybranyZakres?.id_wspolnoty,
        okresPoczatek: dataFormat3(wybranyZakres?.okres_poczatek),
        okresKoniec: dataFormat3(wybranyZakres?.okres_koniec),
        liczbaMsc,
        ile_dni_total,
        cieplaWmPoczatek: wybranyZakres?.ciepla_stan_poczatek,
        cieplaWmKoniec: wybranyZakres?.ciepla_stan_koniec,
        zimnaWmPoczatek: wybranyZakres?.zimna_stan_poczatek,
        zimnaWmKoniec: wybranyZakres?.zimna_stan_koniec,
        zuzycieWmCiepla: cieplaWm,
        zuzycieWmZimna: zimnaWm,
        zuzycieMCiepla: cieplaM,
        zuzycieMZimna: zimnaM,
        zuzycieM,
        strata,
        odczytyWZakresie,
        procenty,
        mocZamowiona: wybranyZakres?.moc_zamowiona,
        energiaPobrana: wybranyZakres?.energia_pobrana,
        podgrzanieWody,
        metr_3_zimnej: wybranyZakres?.metr_3_zimnej,
        kosztPodgrzaniaCieplej,
        abonament_dzien,
        metrazRazem: zaokr(metrazRazem, 2),
        abonamentRazem: zaokr(abonamentRazem, 2),
        kosztZimnejRazem: zaokr(kosztZimnejRazem),
        kosztPodgrzaniaRazem: zaokr(kosztPodgrzaniaRazem),
        razemZwCwAboTotal,
        strataTotal,
        opublikowany: wybranyZakres?.opublikowany,
        miesiac,
        opis,
        zaliczkaZimnaTotal: zaokr(zaliczka_zimna_total),
        zaliczkaCieplaTotal: zaokr(zaliczka_ciepla_total),
        zaliczkaAbonament: zaokr(zaliczka_abonament_total),
        zaliczkaTotal: zaokr(zaliczka_total),
        saldoTotal: zaokr(zaliczka_total - (razemZwCwAboTotal + strataTotal))
    } 
}

export const czyRozliczenieWodyWmAkt = (w, s) => {
    /*console.log(w);
    console.log(s);*/
    
        // console.log(zaokr(w?.abonamentRazem) != zaokr(s?.abonamentRazem) ? `${zaokr(w?.abonamentRazem)}, ${zaokr(s?.abonamentRazem)}` : '');
        // console.log(w?.abonament_dzien != s?.abonament_dzien ? `${w?.abonament_dzien}, ${s?.abonament_dzien}` : '');
        // console.log(w?.cieplaWmKoniec != s?.cieplaWmKoniec ? `${w?.cieplaWmKoniec}, ${s?.cieplaWmKoniec}` : '');
        // console.log(w?.cieplaWmPoczatek != s?.cieplaWmPoczatek ? `${w?.cieplaWmPoczatek}, ${s?.cieplaWmPoczatek}` : '');
        // console.log(w?.energiaPobrana != s?.energiaPobrana ? `${w?.energiaPobrana}, ${s?.energiaPobrana}` : '');
        // console.log(w?.id != s?.id_odczytu_wm ? `${w?.id}, ${s?.id_odczytu_wm}` : '');
        // console.log(w?.id_wspolnoty != s?.id_wspolnoty ? `${w?.id_wspolnoty}, ${s?.id_wspolnoty}` : '');
        // console.log(w?.kosztPodgrzaniaCieplej != s?.kosztPodgrzaniaCieplej ? `${w?.kosztPodgrzaniaCieplej}, ${s?.kosztPodgrzaniaCieplej}` : '');
        // console.log(w?.kosztPodgrzaniaRazem != s?.kosztPodgrzaniaRazem ? `${w?.kosztPodgrzaniaRazem}, ${s?.kosztPodgrzaniaRazem}` : '');
        // console.log(w?.kosztZimnejRazem != s?.kosztZimnejRazem ? `${w?.kosztZimnejRazem}, ${s?.kosztZimnejRazem}` : '');
        // console.log(w?.liczbaMsc != s?.liczbaMsc ? `${w?.liczbaMsc}, ${s?.liczbaMsc}` : '');
        // console.log(w?.metr_3_zimnej != s?.metr_3_zimnej ? `${w?.metr_3_zimnej}, ${s?.metr_3_zimnej}` : '');
        // console.log(zaokr(w?.metrazRazem) != zaokr(s?.metrazRazem) ? `${zaokr(w?.metrazRazem)}, ${zaokr(s?.metrazRazem)}` : '');
        // console.log(w?.miesiac != s?.miesiac ? `${w?.miesiac}, ${s?.miesiac}` : '');
        // console.log(w?.mocZamowiona != s?.mocZamowiona ? `${w?.mocZamowiona}, ${s?.mocZamowiona}` : '');
        // console.log(w?.okresKoniec != dataFormat3(s?.okresKoniec) ? `${w?.okresKoniec}, ${dataFormat3(s?.okresKoniec)}` : '');
        // console.log(w?.okresPoczatek != dataFormat3(s?.okresPoczatek) ? `${w?.okresPoczatek}, ${dataFormat3(s?.okresPoczatek)}` : '');
        // console.log(w?.opis != s?.opis ? `${w?.opis}, ${s?.opis}` : '');
        // console.log(w?.opublikowany != s?.opublikowany ? `${w?.opublikowany}, ${s?.opublikowany}` : '');
        // console.log(w?.podgrzanieWody != s?.podgrzanieWody ? `${w?.podgrzanieWody}, ${s?.podgrzanieWody}` : '');
        // console.log(zaokr(w?.razemZwCwAboTotal, 2) != zaokr(s?.razemZwCwAboTotal, 2) ? `${w?.razemZwCwAboTotal}, ${s?.razemZwCwAboTotal}` : '');
        // console.log(zaokr(w?.saldoTotal) != zaokr(s?.saldoTotal) ? `${zaokr(w?.saldoTotal)}, ${zaokr(s?.saldoTotal)}` : '');
        // console.log(w?.strata != s?.strata ? `${w?.strata}, ${s?.strata}` : '');
        // console.log(w?.strataTotal != s?.strataTotal ? `${w?.strataTotal}, ${s?.strataTotal}` : '');
        // console.log(zaokr(w?.zaliczkaAbonament) != zaokr(s?.zaliczkaAbonament) ? `${zaokr(w?.zaliczkaAbonament)}, ${zaokr(s?.zaliczkaAbonament)}` : '');
        // console.log(zaokr(w?.zaliczkaCieplaTotal) != zaokr(s?.zaliczkaCieplaTotal) ? `${zaokr(w?.zaliczkaCieplaTotal)}, ${zaokr(s?.zaliczkaCieplaTotal)}` : '');
        // console.log(zaokr(w?.zaliczkaTotal) != zaokr(s?.zaliczkaTotal) ? `${zaokr(w?.zaliczkaTotal)}, ${zaokr(s?.zaliczkaTotal)}` : '');
        // console.log(zaokr(w?.zaliczkaZimnaTotal) != zaokr(s?.zaliczkaZimnaTotal) ? `${zaokr(w?.zaliczkaZimnaTotal)}, ${zaokr(s?.zaliczkaZimnaTotal)}` : '');
        // console.log(w?.zimnaWmKoniec != s?.zimnaWmKoniec ? `${w?.zimnaWmKoniec}, ${s?.zimnaWmKoniec}` : '');
        // console.log(w?.zimnaWmPoczatek != s?.zimnaWmPoczatek ? `${w?.zimnaWmPoczatek}, ${s?.zimnaWmPoczatek}` : '');
        // console.log(w?.zuzycieM != s?.zuzycieM ? `${w?.zuzycieM}, ${s?.zuzycieM}` : '');
        // console.log(w?.zuzycieMCiepl != s?.zuzycieMCiepl ? `${w?.zuzycieMCiepl}, ${s?.zuzycieMCiepl}` : '');
        // console.log(w?.zuzycieMZimna != s?.zuzycieMZimna ? `${w?.zuzycieMZimna}, ${s?.zuzycieMZimna}` : '');
        // console.log(w?.zuzycieWmCiepla != s?.zuzycieWmCiepla ? `${w?.zuzycieWmCiepla}, ${s?.zuzycieWmCiepla}` : '');
        // console.log(w?.zuzycieWmZimna != s?.zuzycieWmZimna ? `${w?.zuzycieWmZimna}, ${s?.zuzycieWmZimna}` : '') ;
    if ( 
        w?.id > 0 && s?.id_odczytu_wm > 0 &&
        zaokr(w?.abonamentRazem) == zaokr(s?.abonamentRazem) &&
        w?.abonament_dzien == s?.abonament_dzien &&
        w?.cieplaWmKoniec == s?.cieplaWmKoniec &&
        w?.cieplaWmPoczatek == s?.cieplaWmPoczatek &&
        w?.energiaPobrana == s?.energiaPobrana &&
        w?.id == s?.id_odczytu_wm &&
        w?.id_wspolnoty == s?.id_wspolnoty &&
        w?.kosztPodgrzaniaCieplej == s?.kosztPodgrzaniaCieplej &&
        w?.kosztPodgrzaniaRazem == s?.kosztPodgrzaniaRazem &&
        w?.kosztZimnejRazem == s?.kosztZimnejRazem &&
        w?.liczbaMsc == s?.liczbaMsc &&
        w?.metr_3_zimnej == s?.metr_3_zimnej &&
        zaokr(w?.metrazRazem) == zaokr(s?.metrazRazem) &&
        w?.miesiac == s?.miesiac &&
        w?.mocZamowiona == s?.mocZamowiona &&
        w?.okresKoniec == dataFormat3(s?.okresKoniec) &&
        w?.okresPoczatek == dataFormat3(s?.okresPoczatek) &&
        w?.opis == s?.opis &&
        w?.opublikowany == s?.opublikowany &&
        w?.podgrzanieWody == s?.podgrzanieWody &&
        zaokr(w?.razemZwCwAboTotal,2) == zaokr(s?.razemZwCwAboTotal, 2) &&
        zaokr(w?.saldoTotal) == zaokr(s?.saldoTotal) &&
        w?.strata == s?.strata &&
        w?.strataTotal == s?.strataTotal &&
        zaokr(w?.zaliczkaAbonament) == zaokr(s?.zaliczkaAbonament) &&
        zaokr(w?.zaliczkaCieplaTotal) == zaokr(s?.zaliczkaCieplaTotal) &&
        zaokr(w?.zaliczkaTotal) == zaokr(s?.zaliczkaTotal) &&
        zaokr(w?.zaliczkaZimnaTotal) == zaokr(s?.zaliczkaZimnaTotal) &&
        w?.zimnaWmKoniec == s?.zimnaWmKoniec &&
        w?.zimnaWmPoczatek == s?.zimnaWmPoczatek &&
        w?.zuzycieM == s?.zuzycieM &&
        w?.zuzycieMCiepl == s?.zuzycieMCiepl &&
        w?.zuzycieMZimna == s?.zuzycieMZimna &&
        w?.zuzycieWmCiepla == s?.zuzycieWmCiepla &&
        w?.zuzycieWmZimna == s?.zuzycieWmZimna 
     ) {
        return true;
    } else 
        return false;
}